// extracted by mini-css-extract-plugin
export default {"template3":"styles_template3__FyV4Q"};